import { useContext, useState } from 'react'
import { AgxToast } from '@urbanx/agx-ui-components'
import { AuthContext } from '@urbanx/agx.auth.client'
import { MenuTitles, Pages } from 'constants/menu'
import { useSelectedAgency, useSelectedCampaign } from 'hooks'
import { ContentLayout, PageLayout } from 'layout'
import { AgxToastState } from 'types/commonTypes'
import PropertyInformationSubPage from '../PropertyInformationSubPage'
import TenancyInformationSection from './TenancyInformationSection'
import useTenancyInformationSectionState from './useTenancyInformationSectionState'
import { cleanFullAddress } from '@urbanx/agx.ui-components2'

const TenancyInformationPage = () => {
  const { userAccount } = useContext(AuthContext)
  const { agency } = useSelectedAgency()
  const { campaign } = useSelectedCampaign()
  const [toastState, updateToastState] = useState<AgxToastState>({
    color: 'success',
    message: '',
    open: false,
  })
  const {
    tenancyInformation,
    isPending,
    setTenancyInformation,
    saveState,
    hasUnsavedChanges,
    handleSaveChanges,
  } = useTenancyInformationSectionState({
    campaignId: campaign?.campaignId,
    updateToastState,
  })

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle={agency?.name || ''}
      currentPageTitle={`Campaigns / ${cleanFullAddress(campaign?.address)}`}
      isCampaignsSection={true}
    >
      <ContentLayout
        hasSecondaryMenu={false}
        secondaryActiveMenu={MenuTitles.PROPERTY_INFORMATION}
        isCampaigns={true}
      >
        <AgxToast selector="#agxToast" toastState={toastState} />
        {campaign && (
          <PropertyInformationSubPage
            currentPage={Pages.PROPERTY_INFORMATION_TENANCY_INFORMATION}
            isLoading={isPending}
            saveState={saveState}
            hasUnsavedChanges={hasUnsavedChanges}
            onSave={handleSaveChanges}
            saveButtonId="tenancyInformationSaveChanges"
            saveButtonTestId="btn-tenancyInformationSaveChanges"
            showChildren={!isPending}
          >
            <TenancyInformationSection
              key={`TenancyInformation-${tenancyInformation?.tenancyType}`}
              tenancyInformation={tenancyInformation}
              setTenancyInformation={setTenancyInformation}
              hasUnsavedChanges={hasUnsavedChanges}
            />
          </PropertyInformationSubPage>
        )}
      </ContentLayout>
    </PageLayout>
  )
}

export default TenancyInformationPage
